import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir8858ScheduleMService {

  constructor(private http: HttpClient) {}

  save8858ScheduleM(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    userSettings: any = {},
    serverConfig: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=vc87d8';
    
    // Merge parameters following AngularJS pattern
    let params = _.merge({}, globalService || {}, filterParams);
    
    // Add missing required parameters
    // These are dynamically added by GlobalService in AngularJS but not passed to Angular
    // Following pattern from other Angular components in the project
    if (!params.scenarioCode) {
      params.scenarioCode = filterParams?.scenarioCode || 
                           filterParams?.scenario_code || 
                           globalService?.scenarioCode || 
                           globalService?.scenario_code || 
                           'RAF'; // Default: Return as Filed (most common scenario)
    }
    
    if (!params.is_issue_key_enabled) {
      params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || 
                                    globalService?.is_issue_key_enabled || 
                                    'N'; // Default: Issue tracking disabled
    }
    
    // Stringify data
    const jsonSettings = JSON.stringify(scheduleSettings);
    const jsonObj = JSON.stringify(scheduleDetails);
    
    // Add required parameters
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = "8858_Schedule_M_Save";
    
    // Add fallback for jcd_key
    if (!params.jcd_key || params.jcd_key === '') {
      params.jcd_key = 250;
    }
    
    // Use application/x-www-form-urlencoded as per migration requirements
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

